import { Component, Input } from '@angular/core';
import { MenuElement } from '../../menu-element';
import _ from 'lodash';

@Component({
    selector: 'adm4-menu-element',
    template: `
    @if (hasTitle) {
      @if ((!menuElement.href || !(menuElement.href | async))) {
        @if (shouldBeDisplayed) {
          <div mat-menu-item class='menu-element-indicated-default menu-item-overflow-x-hidden list-item-shrink'
            [class.selected]='isSelected'
            [disabled]='isDisabled'
            (keyup.enter)='triggerEvent()'
            (click)='triggerEvent()'>
            <adm4-menu-item-wrapper [menuElement]='menuElement'></adm4-menu-item-wrapper>
          </div>
        }
      } @else {
        @if (shouldBeDisplayed) {
          <a mat-menu-item
            [href]='menuElement.href | async' class='menu-element-indicated-default menu-item-overflow-x-hidden' [class.selected]='isSelected' [disabled]='isDisabled'>
            <adm4-menu-item-wrapper [menuElement]='menuElement'></adm4-menu-item-wrapper>
          </a>
        }
      }
    } @else {
      @if (!menuElement.title && shouldBeDisplayed) {
        <mat-divider></mat-divider>
      }
    }
    `,
    styleUrls: ['../../styles/component-specific/mat-menu.scss'],
    standalone: false
})
export class MenuElementComponent {
  @Input() menuElement: MenuElement;

  get hasTitle(): boolean {
    return !_.isEmpty(this.menuElement.title);
  }

  get shouldBeDisplayed(): boolean {
    return !_.isFunction(this.menuElement.displayCondition) || this.menuElement.displayCondition();
  }

  get isSelected(): boolean {
    return _.isFunction(this.menuElement.selectedCondition) && this.menuElement.selectedCondition();
  }

  get isDisabled(): boolean {
    return _.isFunction(this.menuElement.disabledCondition) && this.menuElement.disabledCondition();
  }

  triggerEvent() {
    if (!_.isFunction(this.menuElement.event)) {
      return;
    }

    const disabled = _.isFunction(this.menuElement.disabledCondition) && this.menuElement.disabledCondition() ;

    if (disabled) {
      return;
    }

    this.menuElement.event();
  }
}
